import type { SpawnResult } from "../shared/api";
import type { LifeReport, StatsResponse } from "../shared/stats";

async function getJson<T>(url: string): Promise<T> {
  const res = await fetch(url);
  const body = (await res.json()) as T & { error?: string };
  if (!res.ok) throw new Error(body.error ?? `โหลดข้อมูลไม่สำเร็จ (${res.status})`);
  return body;
}

export function fetchSpawn(seed: string): Promise<SpawnResult> {
  return getJson(`/api/spawn?seed=${encodeURIComponent(seed)}`);
}

export function fetchSharedSpecies(id: number, seed: string): Promise<SpawnResult> {
  return getJson(`/api/species?id=${id}&seed=${encodeURIComponent(seed)}`);
}

/** ส่งสรุปชีวิตที่จบแล้วไปรวมเป็นสถิติของผู้เล่นทั้งหมด ส่งไม่สำเร็จก็ไม่เป็นไร */
export async function reportLife(report: LifeReport): Promise<void> {
  try {
    await fetch("/api/stats/life", { method: "POST", headers: { "content-type": "application/json" }, body: JSON.stringify(report) });
  } catch {
    // ออฟไลน์หรือเซิร์ฟเวอร์มีปัญหา สถิติรวมขาดไปหนึ่งชีวิต เกมยังเล่นได้ปกติ
  }
}

/** สถิติรวม (ถ้าระบุชนิด ได้สถิติของชนิดนั้นด้วย) อัปเดตทุกราว 1 นาทีเพราะ cache ที่ edge */
export function fetchStats(speciesId?: number): Promise<StatsResponse> {
  return getJson(`/api/stats${speciesId ? `?species=${speciesId}` : ""}`);
}
